<template>
  <div class="store-yb-container" :loading="loading">
    <!-- 筛选条件区域 -->
    <div class="filter-box">
      <div class="filter-header">
        <span class="title">库存维护</span>
      </div>
      <div class="filter-content">
        <div class="filter-row">
          <div class="filter-item">
            <span class="label">选择时间范围</span>
            <div class="date-pickers-container">
              <el-date-picker
                v-model="filterParams.startTime"
                type="datetime"
                placeholder="开始日期"
				size="mini"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="'00:00:00'"
              ></el-date-picker>
              <span class="date-separator" style="margin: 12px;color:#606266;">至</span>
              <el-date-picker
                v-model="filterParams.endTime"
                type="datetime"
                placeholder="结束日期"
				size="mini"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="'23:59:59'"
              ></el-date-picker>
            </div>
          </div>
          <div class="filter-item">
            <span class="label">业务类型:</span>
            <!-- 业务类型下拉框 -->
            <el-select
              v-model="businessType"
              placeholder="请选择业务类型"
			  size="mini"
              clearable
              @change="handleBusinessTypeChange"
            >
              <el-option
                v-for="item in ybOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="filter-row">
            <el-button 
              type="primary" 
              icon="el-icon-Ssearch" 
              @click="handleQuery"
			  size="mini"
              :loading="queryLoading"
            >查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset" size="mini">重置</el-button>
          </div>
          <div class="filter-item">
            <el-checkbox v-model="filterParams.uploaded" @change="handleUploadedFilter">已上传</el-checkbox>
            <el-checkbox v-model="filterParams.hasTraceCode">有追溯码</el-checkbox>
            <el-checkbox v-model="filterParams.settled">已结算</el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格区域 - 双表格布局 -->
    <div class="table-container">
      <!-- 左侧表格 - 基本数据 -->
      <div class="left-table-box">
        <div class="table-header">
          双击可查询中心数据(3501=>3508,3502=>3509,3503=>3510,3505=>3511)
          <span class="upload-status-tip" v-if="filteredTableData.length > 0">
            当前显示: {{ filterParams.uploaded ? '已上传' : '未上传' }}数据 (共{{ filteredTableData.length }}条)
          </span>
        </div>
        <el-table
          ref="mainTable"
          :data="filteredTableData"
          border
          stripe
          height="calc(100vh - 420px)"
          @row-dblclick="handleRowDblClick"
          @row-contextmenu="handleRightClick"
          @selection-change="handleSelectionChange"
          @current-change="handleCurrentChangeTable"
          highlight-current-row
          v-loading="tableLoading"
        >
          <el-table-column type="index" label="行号" width="60" align="center"></el-table-column>
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="uploadStatus" label="已上传" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.uploadStatus" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="medListCodg" label="医疗目录编码" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fixmedinsHilistId" label="定点医药机构目录编号" min-width="168" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fixmedinsHilistName" label="定点医药机构目录名称" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fixmedinsBcHNo" label="定点医药机构批次流水号" min-width="180" show-overflow-tooltip></el-table-column>
          
	<!-- 	  <el-table-column prop="bchNo" label="批次号" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="aprvNo" label="批准文号" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="certNo" label="证件号码" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cnt" label="数量" min-width="180" show-overflow-tooltip></el-table-column>
		  <el-table-column prop="drugProdBarc" label="药品条形码" min-width="120" show-overflow-tooltip></el-table-column>
		  <el-table-column prop="dyntNo" label="随货单号" min-width="180" show-overflow-tooltip></el-table-column>
		  <el-table-column prop="invChgOpterName" label="库存变更操作人" min-width="180" show-overflow-tooltip></el-table-column>
		  <el-table-column prop="invCnt" label="库存数量" min-width="180" show-overflow-tooltip></el-table-column>
		  <el-table-column prop="jyCode" label="交易编码" min-width="150" show-overflow-tooltip></el-table-column> -->
          <el-table-column prop="invChgTime" label="库存变更时间" min-width="150" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="status" label="状态" min-width="80" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="handleViewTraceCode(scope.row)">查看追溯码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右侧表格 - 追溯码信息 -->
      <div class="right-table-box">
        <div class="table-header">追溯码信息</div>
        <el-table
          :data="currentTraceCodeData"
          border
          stripe
          height="calc(100vh - 420px)"
          empty-text="请选择左侧数据查看追溯码信息"
          v-loading="traceCodeLoading"
        >
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="code" label="追溯码" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '有效'" type="success">有效</el-tag>
              <el-tag v-else type="danger">无效</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="160" align="center"></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <div class="pagination-info">
        共{{ total }}行 共{{ Math.ceil(total / pageSize) }}页 每页{{ pageSize }}行 当前第{{ currentPage }}页 耗时{{ queryTime }}毫秒
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="button-box">
      <el-button size="mini" type="primary" @click="handleUseTransaction">使用带A的交易</el-button>
      <el-button size="mini" @click="handleExport">按时导出数据</el-button>
      <!-- <el-button size="mini" @click="handleViewTraceCodeInfo">查看追溯码信息(3512)</el-button> -->
      <el-button 
        size="mini" 
        @click="handleQueryStorageInfo"
        :disabled="isQueryStorageDisabled"
      >
        库存信息查询 (3508)
      </el-button>
	  <el-button size="mini" @click="handleViewInShop">商品采购信息查询(3510)</el-button>
	  <el-button 
        size="mini" 
        @click="handleViewInPay"
        :loading="payQueryLoading"
      >
        商品销售信息查询(3511)
      </el-button>
      <el-button size="mini" @click="handleOtherFunction">商品追数信息查询(3513)</el-button>
      <el-button size="mini" @click="handleDeleteItem">商品信息删除本条(3507)</el-button>
      <el-button size="mini" @click="handleSelectAll">全选</el-button>
      <el-button 
        size="mini" 
        type="success" 
        @click="handleUpload"
        :disabled="isUploadDisabled"
        :class="{ 'upload-btn-disabled': isUploadDisabled }"
      >
        上传
        <span v-if="isUploadDisabled">(已上传数据不可重复上传)</span>
      </el-button>
    </div>
	
	<!-- 操作进度模态框 -->
	<el-dialog
	    title="操作执行中..."
	    :visible.sync="operationModalVisible"
	    width="40%"
	    :close-on-click-modal="false"
	    :show-close="false"
	    :close-on-press-escape="false"
	  >
	    <div class="operation-progress-container">
	      <!-- 状态提示 -->
	      <div class="status-messages">
	        <div v-for="(step, index) in operationSteps" :key="index" class="status-item">
	          <span>{{ step.text }}</span>
	          <span class="status-icon">
	            <i v-if="step.status === 'success'" class="el-icon-success" style="color: #67C23A"></i>
	            <i v-else-if="step.status === 'error'" class="el-icon-error" style="color: #F56C6C"></i>
	            <i v-else class="el-icon-loading" style="color: #409EFF"></i>
	          </span>
	        </div>
	      </div>
	
	      <!-- 进度条 -->
	      <el-progress
	        :percentage="operationProgress"
	        :stroke-width="12"
	        style="margin-top: 20px;"
	      ></el-progress>
	
	      <!-- 步骤提示信息 -->
	      <div class="step-messages" v-if="operationStepMessages.length > 0">
	        <div v-for="(msg, index) in operationStepMessages" :key="index" 
	             :class="['step-message', msg.class]">
	          <span class="time">[{{ msg.time }}]</span>
	          <span>{{ msg.text }}</span>
	        </div>
	      </div>
	    </div>
	</el-dialog>
	  
    <!-- 右键菜单 -->
    <div
      v-show="contextMenuVisible"
      class="context-menu"
      :style="{ left: contextMenuLeft + 'px', top: contextMenuTop + 'px' }"
    >
      <div class="menu-item" @click="handleContextMenuUpload">上传医保采购信息</div>
      <!-- 新增的删除选项 -->
      <div class="menu-subtitle">删除交易数据:</div>
      <div class="menu-item" @click="handleDeleteByType(1)">删除盘存信息【3501】</div>
      <div class="menu-item" @click="handleDeleteByType(2)">删除库存变更信息【3502】</div>
      <div class="menu-item" @click="handleDeleteByType(3)">删除采购信息【3503/3504】</div>
      <div class="menu-item" @click="handleDeleteByType(4)">删除销售信息【3505/3506】</div>
      <div class="menu-divider"></div>
      <div class="menu-item" @click="handleContextMenuDelete">删除(通用)</div>
      <div class="menu-item" @click="handleContextMenuView">查看详情</div>
    </div>

    <!-- 底部信息栏 -->
    <div class="footer-info">
      <span>{{ userInfo.staffName || '系统管理员' }}->{{ userInfo.medicalInsuranceCode || '无医保编号' }}></span>
      <span>{{ clinicInfo.clinicName + ' > 医保服务中心' || '九阵软件运营中心' }}</span>
      <span>{{ watermarkText || '' }}</span>
    </div>
	<!-- 新增：医保采购信息查询结果模态框 -->
	<yb-purchase-modal 
	  ref="ybPurchaseModal"
	  :visible="ybPurchaseModalVisible" 
	  :query-result="purchaseQueryResult"
	  @update:visible="val => ybPurchaseModalVisible = val"
	  @close="handlePurchaseModalClose"
	/>
  </div>
</template>

<script>
import { getChs, addInfYB } from "@/api/yb/yb-api.js"; // 古

// 导入医保相关API
import { ybapi } from "/src/api/ybapi-psi.js"
import { ybRequestTemplate } from "/src/untils/ybRequestTemplate.js"
import { addYbRquestData, getqdNo, toUploadLY, changeYB } from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";

// 导入封装的接口
import { deleteMedicalInsurance } from "@/api/yb/3507DeleteYB.js";
import { queryMedicalInsuranceStorage } from "@/api/yb/3508QueryYB.js";
import { queryMedicalInsuranceStorage3510 } from "@/api/yb/3510QueryYB.js";
// 新增导入3511和3512接口
import { queryMedicalInsuranceStorage3511 } from "@/api/yb/3511QueryYB.js";
import { queryMedicalInsuranceStorage3512 } from "@/api/yb/3512QueryYB.js";
import YbPurchaseModal from './ybHistory.vue';
export default {
  name: 'StoreMaintenance',
  components: {
      YbPurchaseModal
    },
  data() {
    return {
      // 新增医保上传相关数据
      signNo: '',
	  loading: false,
      machineId: 'default_machine_id',
      updateResult: null,
	  ybPurchaseModalVisible: false,
	  purchaseQueryResult: null,
      changeYBResult: null,
      lyToInventoryId: '',
      operationModalVisible: false,
      operationProgress: 0,
      operationSteps: [
        { text: '数据准备', status: '' },
        { text: '执行上传', status: '' },
        { text: '结果验证', status: '' },
        { text: '记录日志', status: '' }
      ],
      operationStepMessages: [],
      // 新增加载状态
      traceCodeLoading: false,
      payQueryLoading: false,
      // 筛选参数
      filterParams: {
        startTime: '',
        endTime: '',
        uploaded: false,
        hasTraceCode: false,
        settled: false
      },
      businessType: '3503',
      // 原始表格数据
      originalTableData: [],
      // 筛选后的表格数据
      filteredTableData: [],
      // 业务类型选项
      ybOptions: [
        { value: '3501', label: '医保盘存(3501)' },
        { value: '3502', label: '库存变更(3502)' },
        { value: '3503', label: '商品采购(3503)' },
        { value: '3504', label: '商品退库(3504)' },
        { value: '3505', label: '商品销售(3505)' },
        { value: '3506', label: '商品销售退货(3506)' },
        { value: '3507', label: '商品信息删除(3507)' },
        { value: '3508', label: '定点医药机构商品库存信息查询(3508)' },
        { value: '3509', label: '定点医药机构商品库存变更记录查询(3509)' },
        { value: '3510', label: '定点医药机构商品采购信息查询(3510)' },
        { value: '3511', label: '定点医药机构商品销售信息查询(3511)' },
        { value: '3512', label: '入库药品追溯信息查询(3512)' },
        { value: '3513', label: '销售药品追溯信息查询(3513)' }
      ],
	  ybHistoryVisible: true,
	  currentQueryResult: null,
      isQueryStorageDisabled: true, // 库存信息查询按钮禁用状态
      // 当前选中的表格行
      currentRow: null,
      // 当前选中的多行数据
      selectedRows: [],
      // 当前显示的追溯码数据
      currentTraceCodeData: [],
      // 分页数据
      total: 0,
      pageNum: 1,
      pageSize: 10,
      currentPage: 1,
      queryTime: 0,
      // 用户信息
      userInfo: {},
      clinicInfo: {},
      watermarkText: '',
      // 上传按钮禁用状态
      isUploadDisabled: true,
      // 追溯码数据
      traceCodeData: {},
      // 右键菜单
      contextMenuVisible: false,
      contextMenuLeft: 0,
      contextMenuTop: 0,
      // API查询参数
      queryParams: {
        startTime: '',
        endTime: '',
        businessType: '3503',
        pageNum: 1,
        pageSize: 10
      },
      // 加载状态
      queryLoading: false,
      tableLoading: false
    };
  },

  created() {
    // 初始化数据
    this.filteredTableData = [...this.originalTableData];
    // 从本地存储获取用户信息和诊所信息
    this.loadUserInfo();
    this.loadClinicInfo();
    // 页面加载时不设置默认时间，保持为空字符串
    this.loadData();
  },

  methods: {
    // 数据源 
    async loadData() {
      this.queryLoading = true;
      this.tableLoading = true;

      try {
        // 确保时间参数已更新
        this.queryParams.startTime = this.filterParams.startTime;
        this.queryParams.endTime = this.filterParams.endTime;
        this.queryParams.businessType = this.businessType;
        this.queryParams.pageNum = this.pageNum;
        this.queryParams.pageSize = this.pageSize;

        let res = await getChs(this.queryParams);

        if (res.code === 200 && res.data && res.data.content) {
          this.filteredTableData = res.data.content;
          this.total = res.data.totalSize || 0;
          this.$message({ type: 'success', message: '数据加载成功' });
        } else {
          this.$message({ type: 'error', message: res.message || '数据加载失败' });
          this.filteredTableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message({ type: 'error', message: '数据加载失败，请检查网络连接' });
        this.filteredTableData = [];
        this.total = 0;
      } finally {
        // 无论成功或失败，都关闭加载状态
        this.queryLoading = false;
        this.tableLoading = false;
      }
    },

    // 从本地存储加载用户信息
    loadUserInfo() {
      try {
        this.watermarkText = localStorage.getItem('watermarkText') || '医保数据管理系统 v2.0';
        const userInfoStr = localStorage.getItem('userInfo') || '{"staffName": "张医生", "medicalInsuranceCode": "YZ2025001"}';
        if (userInfoStr) {
          this.userInfo = JSON.parse(userInfoStr);
        } else {
          console.warn('未找到用户信息');
          this.userInfo = {
            staffName: '系统管理员',
          };
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
        this.userInfo = {
          staffName: '系统管理员',
        };
      }
    },

    // 从本地存储加载诊所信息
    loadClinicInfo() {
      try {
        const clinicInfoStr = localStorage.getItem('userInfo') || '{"clinicName": "九阵软件运营中心院区"}';
        if (clinicInfoStr) {
          this.clinicInfo = JSON.parse(clinicInfoStr);
        } else {
          console.warn('未找到诊所信息');
          this.clinicInfo = {
            clinicName: ''
          };
        }
      } catch (error) {
        console.error('解析诊所信息失败:', error);
        this.clinicInfo = {
          clinicName: ''
        };
      }
    },

    // 业务类型变更处理
    handleBusinessTypeChange(value) {
      this.businessType = value;
    },

    // 处理已上传筛选
    handleUploadedFilter() {
      if (this.filterParams.uploaded) {
        // 筛选出已上传的数据
        this.filteredTableData = this.originalTableData.filter(item => item.uploadStatus);
      } else {
        // 筛选出未上传的数据
        this.filteredTableData = this.originalTableData.filter(item => !item.uploadStatus);
      }
      // 清除选中状态
      this.selectedRows = [];
      this.updateUploadButtonState();
    },

    // 表格行选中变化
    handleCurrentChangeTable(currentRow) {
      this.currentRow = currentRow;
      // 更新按钮禁用状态
      this.isQueryStorageDisabled = !currentRow;

      if (currentRow && currentRow.batchSerialNumber) {
        this.currentTraceCodeData = this.traceCodeData[currentRow.batchSerialNumber] || [];
      } else {
        this.currentTraceCodeData = [];
      }
    },

    // 处理多选变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      this.updateUploadButtonState();
    },

    // 更新上传按钮状态
    updateUploadButtonState() {
      if (this.selectedRows.length === 0) {
        // 没有选中任何行时禁用上传按钮
        this.isUploadDisabled = true;
        return;
      }

      // 检查所有选中行，如果任何一行已上传，则禁用上传按钮
      const hasUploaded = this.selectedRows.some(row => row.uploadStatus);
      this.isUploadDisabled = hasUploaded;
    },

    // 在methods中添加handleDeleteByType方法
    async handleDeleteByType(invDataType) {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        this.contextMenuVisible = false;
        return;
      }

      try {
        // 确认删除操作
        let confirmMessage = '';
        switch (invDataType) {
          case 1:
            confirmMessage = '确定要删除这条医保盘存信息(3501)吗？';
            break;
          case 2:
            confirmMessage = '确定要删除这条医保库存变更信息(3502)吗？';
            break;
          case 3:
            confirmMessage = '确定要删除这条医保采购信息(3503/3504)吗？';
            break;
          case 4:
            confirmMessage = '确定要删除这条医保销售信息(3505/3506)吗？';
            break;
          default:
            confirmMessage = '确定要删除这条医保信息吗？';
        }

        await this.$confirm(confirmMessage + '此操作将同步删除医保系统中的数据', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 执行删除操作
        await this.executeWithProgress('医保信息删除', async () => {
          await this.handleMedicalInsuranceDelete(this.currentRow, invDataType);
        }, true);

        this.$message.success('医保信息删除成功');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('医保信息删除失败:', error);
          this.$message.error('医保信息删除失败: ' + error.message);
        }
      } finally {
        this.contextMenuVisible = false;
      }
    },

    // 查询处理
    handleQuery() {
      // 确保时间参数已更新
      this.queryParams.startTime = this.filterParams.startTime;
      this.queryParams.endTime = this.filterParams.endTime;
      this.queryParams.businessType = this.businessType;

      // 重置到第一页
      this.pageNum = this.pageNum;
      this.currentPage = this.pageNum;

      // 加载数据
      this.loadData();
    },

    // 重置查询条件
    handleReset() {
      // 重置筛选参数
      this.filterParams = {
        startTime: '',
        endTime: '',
        uploaded: false,
        hasTraceCode: false,
        settled: false
      };

      // 重置业务类型
      this.businessType = '3503';

      // 重置查询参数
      this.queryParams = {
        startTime: '',
        endTime: '',
        businessType: '3503',
        pageNum: 1,
        pageSize: this.pageSize
      };

      // 重置表格数据
      this.filteredTableData = [...this.originalTableData];
      this.selectedRows = [];
      this.updateUploadButtonState();

      this.$message.info('已重置查询条件');
    },

    // 双击行事件
    handleRowDblClick(row) {
      console.log('双击行:', row);
      this.$message.info(`已双击行: ${row.institutionCatalogName}`);
    },

    // 右键点击事件
    handleRightClick(row, column, event) {
      this.currentRow = row;
      this.contextMenuVisible = true;
      this.contextMenuLeft = event.clientX;
      this.contextMenuTop = event.clientY;
      event.preventDefault();
    },

    // 查看追溯码 - 调用3512接口
    async handleViewTraceCode(row) {
      console.log('查看追溯码:', row);
      this.handleCurrentChangeTable(row);
      
      try {
        this.traceCodeLoading = true;
        
        // 确保时间参数已更新
        const startTime = this.filterParams.startTime;
        const endTime = this.filterParams.endTime;

        if (!startTime || !endTime) {
          this.$message.warning('请先选择时间范围');
          return;
        }

        await this.executeWithProgress('商品追溯信息查询', async () => {
          const result = await this.handleMedicalInsuranceTraceQuery(row, startTime, endTime);
          
          // 处理返回的追溯码数据
          if (result && result.output && result.output.data) {
            this.currentTraceCodeData = result.output.data.map(item => ({
              code: item.drug_trac_codg || '',
              status: item.vali_flag === '1' ? '有效' : '无效',
              createTime: item.crte_time || '',
              updateTime: item.updt_time || ''
            }));
            
            this.$message.success(`查询到 ${this.currentTraceCodeData.length} 条追溯码信息`);
          }
        });

      } catch (error) {
        console.error('商品追溯信息查询失败:', error);
        this.$message.error('商品追溯信息查询失败: ' + error.message);
        this.currentTraceCodeData = [];
      } finally {
        this.traceCodeLoading = false;
      }
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryParams.pageSize = val;
      this.handleQuery();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pageNum = val;
      this.currentPage = val;
      this.queryParams.pageNum = val;
      this.handleQuery();
    },

    // 各种按钮操作
    handleUseTransaction() {
      this.$message.info('使用带A的交易');
    },

    handleExport() {
      this.$message.info('导出数据');
    },

    handleViewTraceCodeInfo() {
      this.$message.info('查看追溯码信息');
    },

    // 商品采购信息查询 => 3510
    async handleViewInShop() {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        return;
      }
    
      try {
        this.shopQueryLoading = true;
        
        // 确保时间参数已更新
        const startTime = this.filterParams.startTime;
        const endTime = this.filterParams.endTime;
    
        if (!startTime || !endTime) {
          this.$message.warning('请先选择时间范围');
          this.shopQueryLoading = false;
          return;
        }
    
        const queryResult = await this.executeWithProgress('商品采购信息查询', async () => {
          return await this.handleMedicalInsurancePurchaseQuery(this.currentRow, startTime, endTime);
        });
    
        if (queryResult && queryResult.infcode === 0) {
          this.$message.success('商品采购信息查询成功');
          
          // 保存查询结果 - 直接将output.data赋值给purchaseQueryResult
          this.purchaseQueryResult = queryResult.output || [];
          console.log('查询结果数据:', this.purchaseQueryResult);
    
          // 显示加载状态
          this.loading = true;
          
          // 延迟1秒后打开模态框，实现丝滑效果
          setTimeout(() => {
            this.ybPurchaseModalVisible = true;
            this.loading = false;
          }, 1000);
          
          return queryResult;
        } else {
          throw new Error('商品采购信息查询失败');
        }
      } catch (error) {
        console.error('商品采购信息查询失败:', error);
        this.$message.error('商品采购信息查询失败: ' + error.message);
        this.loading = false;
      } finally {
        this.shopQueryLoading = false;
      }
    },
    
    // 添加handlePurchaseModalClose方法
    handlePurchaseModalClose() {
      this.ybPurchaseModalVisible = false;
      this.purchaseQueryResult = null;
    },

    // 商品销售信息查询 => 3511
    async handleViewInPay() {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        return;
      }

      try {
        this.payQueryLoading = true;
        
        // 确保时间参数已更新
        const startTime = this.filterParams.startTime;
        const endTime = this.filterParams.endTime;

        if (!startTime || !endTime) {
          this.$message.warning('请先选择时间范围');
          return;
        }

        await this.executeWithProgress('商品销售信息查询', async () => {
          const result = await this.handleMedicalInsuranceSaleQuery(this.currentRow, startTime, endTime);
          
          // 可以在这里处理返回的销售信息数据
          if (result && result.output && result.output.data) {
            this.$message.success(`查询到 ${result.output.data.length} 条销售信息`);
            // 可以根据需要将数据显示在界面上
          }
        });

        this.$message.success('商品销售信息查询成功');
      } catch (error) {
        console.error('商品销售信息查询失败:', error);
        this.$message.error('商品销售信息查询失败: ' + error.message);
      } finally {
        this.payQueryLoading = false;
      }
    },

    // 在methods中添加handleQueryStorageInfo方法
    async handleQueryStorageInfo() {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        return;
      }

      try {
        await this.executeWithProgress('医保库存信息查询', async () => {
          await this.handleMedicalInsuranceStorageQuery(this.currentRow);
        });

        this.$message.success('医保库存信息查询成功');
      } catch (error) {
        console.error('医保库存信息查询失败:', error);
        this.$message.error('医保库存信息查询失败: ' + error.message);
      }
    },

    // 添加医保库存信息查询方法
    async handleMedicalInsuranceStorageQuery(row) {
      console.log('===== 开始执行医保库存信息查询流程(3508) =====');

      if (!row) {
        throw new Error('未获取到有效的行数据');
      }

      // 准备用户和诊所信息
      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');

      // 调用外部3508查询方法
      this.addOperationStepMessage('调用医保库存信息查询接口(3508)...');
      const queryResult = await queryMedicalInsuranceStorage(
        row,
        userData,
        clinicInfo,
        this.addStepMessage.bind(this),
        this.addOperationStepMessage.bind(this),
        this.updateOperationProgress.bind(this),
        this.updateOperationStepStatus.bind(this)
      );

      // 处理查询结果
      if (queryResult && queryResult.infcode === 0) {
        this.addOperationStepMessage('医保库存信息查询成功(3508)', { level: 'success' });

        // 这里可以处理查询结果数据，比如显示在界面上
        if (queryResult.output && queryResult.output.data) {
          this.$message.success(`查询到 ${queryResult.output.data.length} 条库存信息`);
          // 可以将查询结果显示在界面上或进行其他处理
        }

        return queryResult;
      } else {
        const errorMsg = queryResult?.err_msg || '未知错误';
        throw new Error(`医保库存信息查询失败(3508): ${errorMsg}`);
      }
    },

    handleOtherFunction() {
      this.$message.info('功能 (3513)');
    },

    handleDeleteItem() {
      this.$message.info('商品信息删除本条 (3507)');
    },

    handleSelectAll() {
      this.$refs.mainTable.toggleAllSelection();
      this.$message.info('全选');
    },

    handleUpload() {
      if (this.isUploadDisabled) {
        this.$message.warning('不能上传已上传的数据');
        return;
      }

      // 模拟上传操作
      this.$message.success('开始上传选中的数据...');

      // 模拟上传过程
      setTimeout(() => {
        // 更新上传状态
        this.selectedRows.forEach(row => {
          const originalRow = this.originalTableData.find(item => item.id === row.id);
          if (originalRow) {
            originalRow.uploadStatus = true;
          }
        });

        // 刷新筛选后的数据
        this.handleUploadedFilter();

        this.$message.success('上传成功！');
      }, 1000);
    },

    // 右键菜单操作 => 调用医保上传功能3503
    async handleContextMenuUpload() {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        this.contextMenuVisible = false;
        return;
      }

      try {
        await this.executeWithProgress('医保采购信息上传', async () => {
          await this.handleMedicalInsuranceUpload(this.currentRow);
        });

        this.$message.success('医保采购信息上传成功');
      } catch (error) {
        console.error('医保采购信息上传失败:', error);
        this.$message.error('医保采购信息上传失败: ' + error.message);
      } finally {
        this.contextMenuVisible = false;
      }
    },

    // 修改右键删除方法
    async handleContextMenuDelete() {
      if (!this.currentRow) {
        this.$message.warning('请先选择一条数据');
        this.contextMenuVisible = false;
        return;
      }

      try {
        // 确认删除操作
        await this.$confirm('确定要删除这条医保信息吗？此操作将同步删除医保系统中的数据', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 执行删除操作
        await this.executeWithProgress('医保信息删除', async () => {
          await this.handleMedicalInsuranceDelete(this.currentRow);
        });

        this.$message.success('医保信息删除成功');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('医保信息删除失败:', error);
          this.$message.error('医保信息删除失败: ' + error.message);
        }
      } finally {
        this.contextMenuVisible = false;
      }
    },

    // 新增医保信息删除方法
    // 修改原有的handleMedicalInsuranceDelete方法，增加invDataType参数
    async handleMedicalInsuranceDelete(row, invDataType = '') {
      console.log('===== 开始执行医保信息删除流程(3507) =====');

      // 直接从行数据获取信息
      this.addOperationStepMessage('从行数据获取删除信息...');

      if (!row) {
        throw new Error('未获取到有效的行数据');
      }

      // 准备用户和诊所信息
      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');

      // 调用外部3507删除方法，传递invDataType参数
      this.addOperationStepMessage('调用医保信息删除接口(3507)...');
      const deleteResult = await deleteMedicalInsurance(
        row,
        userData,
        clinicInfo,
        invDataType, // 新增参数
        this.addStepMessage.bind(this),
        this.addOperationStepMessage.bind(this),
        this.updateOperationProgress.bind(this),
        this.updateOperationStepStatus.bind(this)
      );

      // 处理删除结果
      if (deleteResult && deleteResult.infcode === 0) {
        this.addOperationStepMessage('医保信息删除成功(3507)', { level: 'success' });

        // 更新本地数据状态
        row.uploadStatus = false;
        row.status = '已删除';

        this.$message.success('医保信息删除成功');
        return deleteResult;
      } else {
        const errorMsg = deleteResult?.err_msg || '未知错误';
        throw new Error(`医保信息删除失败(3507): ${errorMsg}`);
      }
    },

    // 新增：商品追溯信息查询方法（3512）
    async handleMedicalInsuranceTraceQuery(row, startTime, endTime) {
      console.log('===== 开始执行商品追溯信息查询流程(3512) =====');

      if (!row) {
        throw new Error('未获取到有效的行数据');
      }

      // 准备用户和诊所信息
      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');

      // 调用外部3512查询方法
      this.addOperationStepMessage('调用商品追溯信息查询接口(3512)...');
      const queryResult = await queryMedicalInsuranceStorage3512(
        row,
        userData,
        clinicInfo,
        startTime, // 传递开始时间
        endTime,   // 传递结束时间
        this.addStepMessage.bind(this),
        this.addOperationStepMessage.bind(this),
        this.updateOperationProgress.bind(this),
        this.updateOperationStepStatus.bind(this)
      );

      // 处理查询结果
      if (queryResult && queryResult.infcode === 0) {
        this.addOperationStepMessage('商品追溯信息查询成功(3512)', { level: 'success' });
        return queryResult;
      } else {
        const errorMsg = queryResult?.err_msg || '未知错误';
        throw new Error(`商品追溯信息查询失败(3512): ${errorMsg}`);
      }
    },

    // 新增：商品销售信息查询方法（3511）
    async handleMedicalInsuranceSaleQuery(row, startTime, endTime) {
      console.log('===== 开始执行商品销售信息查询流程(3511) =====');

      if (!row) {
        throw new Error('未获取到有效的行数据');
      }

      // 准备用户和诊所信息
      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');

      // 调用外部3511查询方法
      this.addOperationStepMessage('调用商品销售信息查询接口(3511)...');
      const queryResult = await queryMedicalInsuranceStorage3511(
        row,
        userData,
        clinicInfo,
        startTime, // 传递开始时间
        endTime,   // 传递结束时间
        this.addStepMessage.bind(this),
        this.addOperationStepMessage.bind(this),
        this.updateOperationProgress.bind(this),
        this.updateOperationStepStatus.bind(this)
      );

      // 处理查询结果
      if (queryResult && queryResult.infcode === 0) {
        this.addOperationStepMessage('商品销售信息查询成功(3511)', { level: 'success' });
        return queryResult;
      } else {
        const errorMsg = queryResult?.err_msg || '未知错误';
        throw new Error(`商品销售信息查询失败(3511): ${errorMsg}`);
      }
    },

    handleContextMenuView() {
      this.$message.info('查看详情');
      this.contextMenuVisible = false;
    },

    // 辅助方法：计算有效期（假设有效期为2年）
    calculateExpiryDate(dateString) {
      if (!dateString) return '';
      return dayjs(dateString).add(2, 'year').format('YYYY-MM-DD');
    },

    // 辅助方法：判断是否为处方药（根据药品名称或编码简单判断）
    getRxFlag(row) {
      const rxKeywords = ['抗生素', '麻醉', '精神', '处方', 'RX'];
      const drugName = row.fixmedinsHilistName || '';

      return rxKeywords.some(keyword => drugName.includes(keyword)) ? '1' : '0';
    },

    // 医保上传核心方法 - 直接从行数据获取信息
    async handleMedicalInsuranceUpload(row) {
      console.log('===== 开始执行医保采购信息更新流程(3503) =====');
		console.log(row,'===== rowrow(3503) =====');
      // 直接从行数据获取信息，不再调用changeYB接口
      this.addOperationStepMessage('从行数据获取采购信息...');

      if (!row) {
        throw new Error('未获取到有效的行数据');
      }

      // 3. 构建医保接口需要的数据格式 - 直接从行数据构建
      this.addOperationStepMessage('构建上传医保采购信息数据...');
      const inventoryChanges = [{
        med_list_codg: row.medListCodg || '',
        fixmedins_hilist_id: row.fixmedinsHilistId || '', // 3503采购信息=> 药品id
        fixmedins_hilist_name: row.fixmedinsHilistName || '', // 3503采购信息=> 药品名称
        dynt_no: row.dyntNo || '',
        fixmedins_bchno: row.fixmedinsBcHNo || '', // 批次流水号
        spler_name: row.splerName || '未知供应商',
        spler_pmtno: row.certNo || '',
        manu_lotnum: row.manuLotnum || '',
        prodentp_name: row.prodentpName || '未知生产商',
        aprvno: row.aprvNo || '', // 批准文号
        manu_date: this.formatDate(row.invChgTime) || dayjs().format('YYYY-MM-DD'),
        expy_end: this.calculateExpiryDate(row.invChgTime) || dayjs().add(2, 'year').format('YYYY-MM-DD'),
        finl_trns_pric: Number(row.finlTrnsPric) || 0,
        purc_retn_cnt: Number(row.purcRetnCnt) || 0,
        purc_invo_codg: row.invoiceNo || '',
        purc_invo_no: row.invoiceCode || '',
        rx_flag: this.getRxFlag(row) || '0',
        purc_retn_stoin_time: row.invChgTime || dayjs().format('YYYY-MM-DD HH:mm:ss'),
        purc_retn_opter_name: row.purcRetnOpterName || '系统操作员',
        prod_geay_flag: '',
        memo: row.remark || `采购单号: ${row.jyCode || '无单号'}`,
      }];

      // 4. 准备医保请求数据
      this.addOperationStepMessage('准备医保请求数据...');
      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');

      // 5. 调用上传医保采购信息接口(3503)
      this.addOperationStepMessage('调用上传医保采购信息接口(3503)...');
      const medicalResult = await this.call3503InventoryChange(inventoryChanges, userData, clinicInfo);

      // 6. 处理响应结果
      if (medicalResult && medicalResult.infcode === 0) {
        this.addOperationStepMessage('医保采购信息更新成功(3503)', { level: 'success' });

        // 7. 调用addInfYB接口记录日志
        this.addOperationStepMessage('医保3505商品采购信息上传成功！正在记录日志信息中...');
        this.updateOperationStepStatus(3, 'loading');
        this.updateOperationProgress(95);
		console.log(this.currentRow,'currentRowcurrentRow');
        // 准备addInfYB接口参数
        const logParams = {
          operationTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          tradingCode: row.jyCode || medicalResult.msgid || `TR${dayjs().format('YYYYMMDDHHmmss')}`,
          ifxType: 1,
          fixmeDinsBchNo: this.currentRow.fixmedinsBcHNo || '',
          personNum: userData.staffId || '',
          settlementId: this.currentRow.fixmedinsHilistId || '',
          smtSerialNum: row.smtSerialNum || row.jyCode || '',
          status: 1 // 1有效
        };

        // 调用addInfYB接口
        const logResult = await addInfYB(logParams);

        if (logResult.code === 200) {
          this.addOperationStepMessage('日志信息保存成功！', { level: 'success' });
          this.updateOperationStepStatus(3, 'success');
          this.updateOperationProgress(100); // 确保进度条到100%

          // 延迟关闭模态框
          setTimeout(() => {
            this.hideOperationModal();
          }, 1000);
        } else {
          this.addOperationStepMessage(`日志信息保存失败: ${logResult.message}`, { level: 'warning' });
          this.updateOperationStepStatus(3, 'error');
          this.updateOperationProgress(100); // 即使失败也完成进度

          // 延迟关闭模态框
          setTimeout(() => {
            this.hideOperationModal();
          }, 1000);
          // 日志保存失败不影响主流程，只记录警告
        }

        // 更新行数据的上传状态
        row.uploadStatus = true;
        this.$message.success('医保采购信息上传成功');

        return medicalResult;
      } else {
        const errorMsg = medicalResult?.err_msg || '未知错误';
        throw new Error(`医保采购信息更新失败(3503): ${errorMsg}`);
      }
    },

    // 辅助方法：格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      return dayjs(dateString).format('YYYY-MM-DD');
    },

    // 构造医保采购信息上传请求
    async call3503InventoryChange(inventoryChanges, userData, clinicInfo) {
      try {
        this.addStepMessage('开始构造医保采购信息上传请求(3503)...');

        const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
        const today = dayjs().format('YYYY-MM-DD');

        // 获取签到编号
        const signNoRes = await getqdNo();
        if (signNoRes.code === 200) {
          this.signNo = signNoRes.data.signNo;
          this.addStepMessage(`签到业务ID: ${this.signNo}`);
        } else {
          throw new Error('获取签到流水号失败');
        }

        // 生成机器ID（截取前20位）
        this.machineId = (this.machineId || 'default_machine_id').slice(0, 20);

        // 设置请求参数
        ybRequest.body.infno = '3503';
        ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`;
        ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
        ybRequest.body.mdtrtarea_admvs = userData.mdtrtareaAdmvs || '';
        ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
        ybRequest.body.recer_sys_code = '007';
        ybRequest.body.infver = 'V1.049';
        ybRequest.body.opter_type = '1';
        ybRequest.body.opter = userData.userId || '1';
        ybRequest.body.opter_name = userData.staffName || '系统操作员';
        ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
        ybRequest.body.fixmedins_code = userData.clinicCode || '';
        ybRequest.body.fixmedins_name = userData.clinicName || '';
        ybRequest.body.sign_no = this.signNo;

        // 设置库存变更数据
        ybRequest.body.input.purcinfo = inventoryChanges.length > 0 ? inventoryChanges[0] : {};

        this.addStepMessage('准备调用接口传输数据(3503)...');

        // 先传给系统
        const newItem = {
          infno: 3503,
          mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
          data: JSON.stringify(ybRequest.body),
          patientId: userData.staffId || '',
          patientName: userData.staffName || '系统操作员'
        };

        const res = await addYbRquestData(newItem);

        if (res.code !== 200) {
          throw new Error('医保数据准备失败: ' + res.message);
        }

        this.addStepMessage('医保数据准备完成，开始上传接口(3503)...');
        this.lyToInventoryId = res.data.id;

        let responseData = res.data;
        if (typeof responseData === 'string') {
          try {
            responseData = JSON.parse(responseData);
          } catch (parseError) {
            throw new Error('解析医保响应数据失败');
          }
        }

        // 设置请求头
        ybRequest.headers.infosyscode = responseData.infosyscode || '';
        ybRequest.headers.hsf_signature = responseData.signature || '';
        ybRequest.headers.fixmedins_code = userData.clinicCode || '';
        ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
        ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';

        this.addStepMessage('调用构造医保采购信息上传请求(3503)...');

        // 调用医保接口
        const axiosConfig = {
          method: 'post',
          url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
          baseURL: '',
          headers: ybRequest.headers,
          data: ybRequest.body,
        };

        const response = await axios(axiosConfig);
        this.updateResult = response.data || response;

        // 处理响应结果
        if (this.updateResult.infcode === 0) {
          this.addStepMessage('构造医保采购信息上传成功(3503)', { level: 'success' });
          return this.updateResult;
        } else {
          let errorMsg = '构造医保采购信息上传请求失败(3503)';
          if (this.updateResult) {
            errorMsg = this.updateResult.err_msg || this.updateResult.msg || this.updateResult.message || '未知错误';
          }
          throw new Error(errorMsg);
        }

      } catch (error) {
        console.error('调用医保采购信息上传接口(3503)异常:', error);
        throw error;
      }
    },

    // 辅助方法
    getRandom4Digits() {
      return Math.floor(1000 + Math.random() * 9000).toString();
    },

    addOperationStepMessage(message, config = {}) {
      const msgObj = {
        text: typeof message === 'string' ? message : JSON.stringify(message),
        time: dayjs().format('HH:mm:ss'),
        level: config.level || 'info',
        class: config.level === 'error' ? 'message-error' :
          (config.level === 'success' ? 'message-success' : 'message-info')
      };

      this.operationStepMessages.push(msgObj);

      if (this.operationStepMessages.length > 10) {
        this.operationStepMessages.shift();
      }
    },

    // 修改executeWithProgress方法以支持删除操作
    async executeWithProgress(operationName, operationFunction, isDelete = false) {
      try {
        this.showOperationModal();

        // 根据操作类型设置不同的步骤
        if (isDelete) {
          this.operationSteps = [
            { text: '数据准备', status: '' },
            { text: '执行删除', status: '' },
            { text: '结果验证', status: '' }
          ];
        } else {
          this.operationSteps = [
            { text: '数据准备', status: '' },
            { text: '执行上传', status: '' },
            { text: '结果验证', status: '' },
            { text: '记录日志', status: '' }
          ];
        }

        this.updateOperationProgress(10);
        this.updateOperationStepStatus(0, 'loading');
        this.addOperationStepMessage(`开始${operationName}...`);

        // 执行第一步：数据准备
        this.updateOperationProgress(30);
        this.addOperationStepMessage('数据准备中...');
        await new Promise(resolve => setTimeout(resolve, 500));
        this.updateOperationStepStatus(0, 'success');
        this.addOperationStepMessage('数据准备完成');

        // 执行第二步：操作执行
        this.updateOperationProgress(60);
        this.updateOperationStepStatus(1, 'loading');
        this.addOperationStepMessage('执行操作中...');

        // 执行实际的操作函数
        const result = await operationFunction();

        this.updateOperationStepStatus(1, 'success');
        this.addOperationStepMessage('操作执行完成');

        // 执行第三步：结果验证
        this.updateOperationProgress(90);
        this.updateOperationStepStatus(2, 'loading');
        this.addOperationStepMessage('验证结果中...');
        await new Promise(resolve => setTimeout(resolve, 300));

        this.updateOperationStepStatus(2, 'success');
        this.addOperationStepMessage(`${operationName}成功完成`);
        this.updateOperationProgress(100);

        // 完成后延迟关闭模态框
        setTimeout(() => {
          this.hideOperationModal();
        }, 1000);

        return result;
      } catch (error) {
        console.error(`${operationName}失败:`, error);
        this.updateOperationStepStatus(2, 'error');
        this.addOperationStepMessage(`${operationName}失败: ${error.message}`, { level: 'error' });
        this.updateOperationProgress(100);

        setTimeout(() => {
          this.hideOperationModal();
        }, 2000);
        throw error;
      }
    },

    showOperationModal() {
      this.operationModalVisible = true;
      this.operationProgress = 0;
      this.operationSteps = this.operationSteps.map(step => ({
        ...step,
        status: ''
      }));
      this.operationStepMessages = [];
    },

    hideOperationModal() {
      this.operationModalVisible = false;
    },

    updateOperationProgress(percentage) {
      this.operationProgress = percentage;
    },

    updateOperationStepStatus(index, status) {
      if (this.operationSteps[index]) {
        this.$set(this.operationSteps, index, {
          ...this.operationSteps[index],
          status: status
        });
      }
    },
    // 修复：添加缺失的 addStepMessage 方法
    addStepMessage(message, config = {}) {
      const msgObj = {
        text: typeof message === 'string' ? message : JSON.stringify(message),
        time: dayjs().format('HH:mm:ss'),
        level: config.level || 'info',
        class: config.level === 'error' ? 'message-error' :
        (config.level === 'success' ? 'message-success' : 'message-info')
		  };
	
		  // 确保stepMessages数组存在
		  if (!this.stepMessages) {
			this.stepMessages = [];
		  }
	
		  this.stepMessages.push(msgObj);
	
		  // 限制消息数量
		  if (this.stepMessages.length > 10) {
			this.stepMessages.shift();
		  }
		},
	
		// 添加商品采购信息查询方法
		async handleMedicalInsurancePurchaseQuery(row, startTime, endTime) {
		  console.log('===== 开始执行商品采购信息查询流程(3510) =====');
		
		  if (!row) {
		    throw new Error('未获取到有效的行数据');
		  }
		
		  // 准备用户和诊所信息
		  const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
		  const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
		
		  // 调用外部3510查询方法，传递时间参数
		  this.addOperationStepMessage('调用商品采购信息查询接口(3510)...');
		  const queryResult = await queryMedicalInsuranceStorage3510(
		    row,
		    userData,
		    clinicInfo,
		    startTime, // 传递开始时间
		    endTime,   // 传递结束时间
		    this.addStepMessage.bind(this),
		    this.addOperationStepMessage.bind(this),
		    this.updateOperationProgress.bind(this),
		    this.updateOperationStepStatus.bind(this)
		  );
		
		  // 处理查询结果
		  if (queryResult && queryResult.infcode === 0) {
		    this.addOperationStepMessage('商品采购信息查询成功(3510)', { level: 'success' });
		    return queryResult;
		  } else {
		    const errorMsg = queryResult?.err_msg || '未知错误';
		    throw new Error(`商品采购信息查询失败(3510): ${errorMsg}`);
		  }
		}
	  },
	
	  mounted() {
		// 点击页面其他区域关闭右键菜单
		document.addEventListener('click', () => {
		  this.contextMenuVisible = false;
		});
	  }
	};
	</script>
	
	<style lang="less">
	.store-yb-container {
	  height: 80vh;
	  display: flex;
	  flex-direction: column;
	  padding: 16px;
	  box-sizing: border-box;
	  overflow: hidden;
	  background-color: #f5f5f7;
	
	  .filter-box {
		background-color: #fff;
		border-radius: 4px;
		padding: 16px;
		margin-bottom: 16px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	
		.filter-header {
		  display: flex;
		  align-items: center;
		  margin-bottom: 16px;
	
		  .title {
			font-size: 16px;
			font-weight: bold;
			color: #409EFF;
		  }
		}
	
		.filter-content {
		  .filter-row {
			display: flex;
			align-items: center;
			margin-bottom: 12px;
			flex-wrap: wrap;
			
			.filter-item {
			  display: flex;
			  margin-left: 12px;
			  align-items: center;
			  margin-right: 16px;
			  margin-bottom: 8px;
	
			  .label {
				margin-right: 8px;
				white-space: nowrap;
				color: #606266;
			  }
			}
		  }
		}
	  }
	
	  .table-container {
		display: flex;
		gap: 16px;
		margin-bottom: 16px;
		flex: 1;
		min-height: 0;
	
		.left-table-box {
		  flex: 7;
		  border: 1px solid #ebeef5;
		  border-radius: 4px;
		  display: flex;
		  flex-direction: column;
		  min-width: 0;
		  background-color: #fff;
		  
		  .table-header {
			font-size: 12px;
			color: #67C23A;
			background-color: #f0f9eb;
			padding: 8px;
			border-radius: 4px 4px 0 0;
			border-bottom: 1px solid #e1f3d8;
		  }
		  
		  .el-table {
			flex: 1;
		  }
		}
	
		.right-table-box {
		  flex: 3;
		  border: 1px solid #ebeef5;
		  border-radius: 4px;
		  display: flex;
		  flex-direction: column;
		  min-width: 0;
		  background-color: #fff;
		  
		  .table-header {
			font-size: 12px;
			color: #67C23A;
			background-color: #f0f9eb;
			padding: 8px;
			border-radius: 4px 4px 0 0;
			border-bottom: 1px solid #e1f3d8;
		  }
		  
		  .el-table {
			flex: 1;
		  }
		}
	  }
	
	  .pagination-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
		background-color: #fff;
		border-radius: 4px;
		margin-bottom: 16px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	
		.pagination-info {
		  font-size: 12px;
		  color: #606266;
		  white-space: nowrap;
		}
	  }
	
	  .button-box {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		padding: 16px;
		background-color: #fff;
		border-radius: 4px;
		margin-bottom: 16px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	  }
	
	  .footer-info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 16px;
		background-color: #409EFF;
		color: white;
		border-radius: 4px;
		font-size: 12px;
		
		span {
		  white-space: nowrap;
		  overflow: hidden;
		  text-overflow: ellipsis;
		  flex: 1;
		  text-align: center;
		  
		  &:first-child {
			text-align: left;
		  }
		  
		  &:last-child {
			text-align: right;
		  }
		}
	  }
	
	  .context-menu {
		position: fixed;
		background-color: #fff;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		z-index: 9999;
	
		.menu-item {
		  padding: 8px 16px;
		  cursor: pointer;
		  font-size: 13px;
	
		  &:hover {
			background-color: #409EFF;
			color: #fff;
		  }
		}
	  }
	  
	  .upload-status-tip {
		margin-left: 10px;
		color: #67C23A;
		font-size: 12px;
	  }
	  
	  .upload-btn-disabled {
		opacity: 0.6;
		cursor: not-allowed;
	  }
	}
	
	@media (max-width: 1600px) {
	  .store-yb-container {
		.table-container {
		  flex-direction: column;
		  
		  .left-table-box,
		  .right-table-box {
			flex: 1;
			width: 100%;
		  }
		}
	  }
	}
	
	@media (max-width: 1200px) {
	  .store-yb-container {
		.button-box {
		  gap: 8px;
		  
		  .el-button {
			margin-bottom: 8px;
		  }
		}
		
		.footer-info {
		  flex-direction: column;
		  gap: 4px;
		  
		  span {
			text-align: center !important;
		  }
		}
	  }
	}
	
	/* 操作进度模态框样式 */
	.operation-progress-container {
	  .status-messages {
		margin-bottom: 20px;
		
		.status-item {
		  display: flex;
		  justify-content: space-between;
		  align-items: center;
		  padding: 8px 0;
		  border-bottom: 1px solid #f0f0f0;
		  
		  &:last-child {
			border-bottom: none;
		  }
		}
	  }
	  
	  .step-messages {
		max-height: 200px;
		overflow-y: auto;
		margin-top: 20px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		padding: 10px;
		
		.step-message {
		  padding: 5px 0;
		  font-size: 12px;
		  
		  .time {
			color: #999;
			margin-right: 8px;
		  }
		  
		  &.message-success {
			color: #67C23A;
		  }
		  
		  &.message-error {
			color: #F56C6C;
		  }
		  
		  &.message-info {
			color: #606266;
		  }
		}
	  }
	}
	
	/* 右键菜单样式 */
	.context-menu {
	  .menu-subtitle {
		padding: 8px 16px;
		font-size: 12px;
		color: #909399;
		background-color: #f5f7fa;
		border-bottom: 1px solid #e6e6e6;
	  }
	  
	  .menu-divider {
		height: 1px;
		background-color: #e6e6e6;
		margin: 4px 0;
	  }
	}
	</style>